import React from "react"

import Icon from "@kit/design/icon"
import Stack from "@kit/design/stack"

import { usePlanComparisonContext } from "./context"

export const creatorFeatures = [
  "Free Recommendations",
  "Paid Recommendations",
  "Remove Kit branding",
  "Smart Recommendations",
  "Apps",
  "RSS campaigns",
  "Polls"
]

const creatorProFeatures = [
  "Advanced A/B testing",
  "Facebook custom audiences",
  "Newsletter referral system",
  "Edit links in sent broadcasts",
  "Subscriber engagement scoring",
  "Deliverability reporting",
  "Insights dashboard",
  "24/7 Priority support"
]

const featureVariants = ({ plan }) => {
  if (!plan) return []

  if (plan.service_level === "creator") {
    return creatorFeatures
  }

  if (plan.service_level === "creator_pro") {
    return creatorProFeatures
  }

  return []
}

const lowerTier = ({ plan }) => {
  if (!plan) return ""

  if (plan.service_level === "creator_pro") {
    return "Creator plan"
  }

  if (plan.service_level === "creator") {
    return "the free plan"
  }

  return ""
}

export function useFeatureList(plan) {
  const defaultFeatures = featureVariants({ plan })
  const { customFeatures = {} } = usePlanComparisonContext()

  return customFeatures[plan?.service_level] || defaultFeatures
}

const FeatureList = ({ plan }) => {
  const lowerTierPlan = lowerTier({ plan })
  const features = useFeatureList(plan)

  return (
    <Stack spacing={4} className="mb-4">
      <p className="font-bold">Everything in {lowerTierPlan} plus:</p>

      {features.map((feature, index) => {
        return (
          <p key={index}>
            <Icon name="check-circle" className="mr-2" aria-hidden="true" />
            {feature}
          </p>
        )
      })}
    </Stack>
  )
}

export default FeatureList
